import React from 'react';
import classNames from 'classnames';
import { useSetAtom } from 'jotai/index';
import Button from '../Button';
import { closeModalAtom } from '../../atoms/modalAtoms';
import styles from './css/index.module.scss';
import { DICTIONARY } from '../../translations/dictionary';
import tStatic from '../../translations';

function InfoModal({
  text,
  note,
  buttonText = tStatic(DICTIONARY.ok),
  onButtonClick,
  buttonLoading,
  // buttonClassName,
}) {
  const closeModal = useSetAtom(closeModalAtom);

  const onClick = (ev) => {
    if (typeof onButtonClick === 'function') {
      onButtonClick(ev);
    } else {
      closeModal();
    }
  };

  return (
    <>
      <p className={classNames(styles.text, { [styles.textWithNote]: note })}>{text}</p>
      {note ? <p className={styles.note}>{note}</p> : null}
      <div className={styles.buttonsRow}>
        <div className={styles.button}>
          <Button
            text={buttonText}
            onClick={onClick}
            isDisabled={buttonLoading}
            width="100%"
          />
        </div>
      </div>
    </>
  );
}

export default InfoModal;
